import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingManagementStore.onSearchJobAction({page: 1, size: PAGE_SIZE_DEFAULT, isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser})
    // marketingManagementStore.onGetGroup()
  }

  handleSearch = () => {
    const {marketingManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'groupName': fieldsValue.groupName,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingManagementStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {marketingManagementStore, location, t} = this.props
    const {groupList} = marketingManagementStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="groupName" label={t(`marketingManagement.groupName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.groupName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            {/* <Col span={6}>
              <Form.Item name="users" label={t(`marketingManagement.groupUser`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.shortName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col> */}
            <Col flex="auto" style={{textAlign: 'right'}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
